import { createClient } from "@supabase/supabase-js";



const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Missing Supabase environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

export type SavedCV = {
  id: string;
  user_id: string;
  title: string;
  job_description: string;
  raw_result: string;
  created_at: string;
  status: "PREVIEW" | "READY" | "APPLIED";
  pdf_path?: string;
  company?: string;
};

export type MasterResume = {
  id: string;
  user_id: string;
  name: string;
  content: string;
  created_at: string;
};
